// $lib/audio.js
const shutterSound = new Audio("/sounds/shutter.mp3");
const recordingSound = new Audio("/sounds/recording.mp3");
const stopRecordingSound = new Audio("/sounds/stop-recording.mp3");
const ringSound = new Audio("/sounds/bicycle-ring.mp3");

function playSound(audio) {
    audio.currentTime = 0; // tua về đầu để phát lại
    audio.play().catch(err => console.warn("Không phát được âm thanh:", err));
}

export function playShutter() {
    playSound(shutterSound);
}

export function playRecording() {
    playSound(recordingSound);
}

export function playStopRecording() {
    playSound(stopRecordingSound);
}

export function playRing() {
    ringSound.loop = true;
    playSound(ringSound);
}

export function stopRing() {
    ringSound.pause();
    ringSound.currentTime = 0;
}

